import EtchEndCap from './EtchEndCap.component';

export default EtchEndCap;